export default {
    prices: {
        ORANE_MONTHLY_PRICE_PER_ACTIVE_EMPLOYEE: 1.0,
        RPIHARDWARE_MONTHLY_PRICE: 29.9,
        PHONEHARDWARE_MONTHLY_PRICE: 16.9,
        PHONESOFTWARE_MONTHLY_PRICE: 2.0,
        TRACCARHARDWARE_MONTHLY_PRICE: 9.9
    }
};